import { defineMessages } from 'react-intl'

export default defineMessages({
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  bulkDescription: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Description',
    defaultMessage: 'Drag and drop a CSV file with all users to be added to the organization'
  },
  pageTitle: {
    id: 'OrganizationUsersBulkAddPage.Title',
    defaultMessage: 'Add Many Organization Users'
  },
  dropZone: {
    id: 'OrganizationUsersBulkAddPage.DropZone.DropCsv',
    defaultMessage: 'Drop or Upload CSV Here'
  },
  bulkLabel: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Label',
    defaultMessage: 'Bulk add users to an organization'
  },
  created: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Results.Created',
    defaultMessage: 'Created'
  },
  failed: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Results.Failed',
    defaultMessage: 'Failed'
  },
  info: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Results.Info',
    defaultMessage: 'Information'
  },
  addingUsers: {
    id: 'OrganizationUsersBulkAddPage.Bulk.AddingUsers',
    defaultMessage: 'Adding users. This may take some time to complete.'
  },
  bulkExample: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Tooltip.Example',
    defaultMessage: 'Examples:'
  },
  downloadSimple: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Tooltip.DownloadSimple',
    defaultMessage: 'simple CSV file'
  },
  downloadAll: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Tooltip.DownloadFull',
    defaultMessage: 'all fields CSV file'
  },
  saveList: {
    id: 'OrganizationUsersBulkAddPage.Bulk.SaveList',
    defaultMessage: 'Save List'
  },
  cancel: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Cancel',
    defaultMessage: 'Cancel'
  },
  cancelling: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Cancelling',
    defaultMessage: 'Cancelling...'
  },
  message: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Column.Message',
    defaultMessage: 'Message'
  },
  username: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Column.Username',
    defaultMessage: 'Username'
  },
  line: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Column.Line',
    defaultMessage: 'Line'
  },
  validationHelp: {
    id: 'OrganizationUsersBulkAddPage.Bulk.ValidationHelp',
    defaultMessage: 'Errors were found in the CSV formatting. Review the line number and error to update the entry.'
  }
})
